<div class="form-info" *ngIf="formInfo$ | async as formInfo">
  <h1 id="headingforminfo" class="visually-hidden">Formularinformation</h1>
  <h2>{{ formInfo.bekanntmachungsart }}</h2>
  <p *ngIf="formInfo.richtlinie && formInfo.vergaberechtsrahmen">
    {{ formInfo.richtlinie }} - {{ formInfo.vergaberechtsrahmen }}
  </p>
</div>
